<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    JO Number List
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-btn
                    color="primary"
                    class="mr-2"
                    :disabled="!exportData.length || exportBtn"
                    @click.prevent="exportDatas()"
                    :loading="exportBtn"
                  >
                    <!-- <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv> -->
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </v-btn>

                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Select Date
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="selectDate(dates)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <!-- <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date"
                        label="Select Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      :allowed-dates="
                        (date) =>
                          date <=
                          new Date(
                            Date.now() - new Date().getTimezoneOffset() * 64000
                          )
                            .toISOString()
                            .substr(0, 10)
                      "
                      @input="dateMenu = false"
                    ></v-date-picker>
                  </v-menu> -->
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Reference Number, Account Number, Jo No, Name"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              clearable
              @click:clear="getList()"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
          >
            <!-- <template slot="body.append">
              <tr>
                <th>Total</th>
                <th class="text-center">
                  {{ setToLocaleString(getTotal(table.data), 0) }}
                </th>
              </tr>
            </template> -->

            <!-- <template v-slot:header['adasda']>
              <button @click="console.log('you have clicked me')">
                Calories
              </button>
            </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.customer`]="{ item }">
              <a href="#" @click.prevent="showDetails(item)">{{
                item.customer
              }}</a>
            </template> -->

            <template v-slot:[`item.dateApplied`]="{ item }">
              {{ item.createdDate }}
            </template>

            <template v-slot:[`item.affiliate`]="{ item }">
              <template
                v-if="
                  item.affiliate && Object.keys(item.affiliate).length !== 0
                "
              >
                {{ `${item.affiliate.firstname} ${item.affiliate.lastname}` }}
                - {{ item.affiliate.msisdn }}
              </template>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <online-application-dialog
      ref="onlineAppDialog"
    ></online-application-dialog>
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import OnlineApplicationDialog from "../dialogs/acquisition/OnlineApplicationDialog.vue";
import moment from "moment";
export default {
  mixins: [ShareableMethods],
  name: "OnlineForConfirmation",
  components: { OnlineApplicationDialog },
  data() {
    return {
      menu: false,
      modal: false,
      dates: moment().format("YYYY-MM-DD"),
      exportBtn: false,

      exportData: [],
      fileName: "",

      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Customer", value: "customer" },
          { text: "Reference Number", value: "referenceNumber" },
          { text: "Mobile Number", value: "mobileNumber" },
          { text: "Barangay", value: "barangay" },
          { text: "City", value: "city" },
          { text: "Province", value: "province" },
          {
            text: "Date Applied",
            value: "createdDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },
          { text: "Status", value: "status" },
          { text: "JO Number", value: "account.jo_no" },
          {
            text: "Retailer",
            value: "retailer",
            formatter: (x) => (x ? `${x.firstName} ${x.lastName}` : null),
          },
          {
            text: "Dealer",
            value: "dealer",
            formatter: (x) => (x ? `${x.firstName} ${x.lastName}` : null),
          },
          { text: "Distributor", value: "distributor.companyName" },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {

    async exportDatas () {
      this.exportBtn = true;
      await this.$api
        .post(
          `/export?startDate=${this.dates}&endDate=${this.dates}`, {
            method: "joListing"
          }
        )
        .then((response) => {
          this.exportBtn = false;
          const newArr = response.data.data;
          window.open(newArr.link, '_blank', 'noopener, noreferrer');

         
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
    // customSort(items, index, isDesc) {
    //   console.log(items, index, isDesc)
    //   items.sort((a, b) => {
    //     if (index === "date") {
    //       if (!isDesc) {
    //         // eslint-disable-next-line no-undef
    //         return compare(a.date, b.date);
    //       } else {
    //         // eslint-disable-next-line no-undef
    //         return compare(b.date, a.date);
    //       }
    //     }
    //   });
    //   return items;
    // },
    async getList(searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;
      await this.$api
        .get(
          `/jo/listing?date=${this.dates}&page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`
        )
        .then((response) => {
          const newArr = response.data.data;
          console.log(newArr);

          newArr.subscribers.map((obj) => {
            obj.customer = obj.firstName + " " + obj.lastName;
          });

          console.log(newArr.subscribers);

          this.table.data = newArr.subscribers;
          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          this.exportExcel(newArr.subscribers);
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    getTotal(data) {
      return data.reduce((partialSum, a) => partialSum + a.count, 0);
    },

    async showDetails(item) {
      await this.$refs.onlineAppDialog
        .open(item, "confirm")
        .then((response) => {
          if (response) {
            // this.table.selected = [];
            this.getList();
          }
        });
    },

    exportExcel(items) {
      let exportData = items.map((item) => {
        return {
          Customer: item.customer,
          "Rereference Number": item.referenceNumber,
          "Mobile Number": item.mobileNumber,
          Barangay: item.barangay,
          City: item.city,
          Province: item.province,
          "Date Applied": this.formatDate(item.createdDate),
          Status: item.status,
          "JO Number": item.account.jo_no,
          Retailer: `${item.retailer.firstName} ${item.retailer.lastName}`,
          Dealer: `${item.dealer.firstName} ${item.dealer.lastName}`,
          Distributor: item.distributor.companyName,
        };
      });
      this.fileName = `JO_NUMBER_LIST_${this.dates}`;
      this.exportData = exportData;
    },

    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },

    selectDate(date) {
      this.getList();
      this.modal = false;
      this.$refs.dialog.save(date);
    },
  },

  mounted() {
    this.getList();
    // console.log(this.$props.headers);
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getList(this.search);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
